import { Pipe, PipeTransform } from '@angular/core';

/*
    Uses Autolinker - to open links in a new window use: | autolinker::{newWindow: true}"
 */

@Pipe({
    name: 'reverseArray'
})
export class ReverseArrayPipe implements PipeTransform {

    transform(value) {
        return value.slice().reverse();
    }
}
